export class SaveErpOrderNFeDestinationAddressInput {
    name?: string;
    publicPlace: string;
    number: string;
    district: string;
    cityName: string;
    state: string;
    zipCode: string;
    additionalAddress: string;
    cpf?: string;
    cnpj?: string;
}

export class SaveErpOrderNFeInput {
    orderId: number;
    erpNfeId?: number;
    nfeNumber: string;
    nfeSeries: string;
    totalFinalValue: number;
    keyNfe: string;
    protocolNumber: number;
    issuedAt: Date;
    nfeDestinationAddress?: SaveErpOrderNFeDestinationAddressInput;
    userId?: number;
}
